import React from 'react'
import Typography from '@material-ui/core/Typography'
import WarningIcon from '@material-ui/icons/Warning'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { withStyles } from '@material-ui/core/styles'
import Styles from '../../../common/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Y from '../../../y18n'
import * as adminActions from '../../../store/admin'

const mapStateToProps = state => ({
  jetshopApiStatus: state.admin.jetshopApiStatus,
  teliaApiStatus: state.admin.teliaApiStatus,
  azureApiStatus: state.admin.azureApiStatus,
  hylteApiStatus: state.admin.hylteApiStatus
})

const mapDispatchToProps = dispatch => ({
  adminActions: bindActionCreators(adminActions, dispatch)
})

class ApiStatus extends React.Component {
  componentDidMount () {
    this.props.adminActions.getAzureApiStatus()
    this.props.adminActions.getTeliaApiStatus()
    this.props.adminActions.getHyltesimApiStatus()
    this.props.adminActions.getJetshopApiStatus()
  }

  renderStatus (apiName, isUp) {
    const icon = isUp
      ? <CheckCircleIcon color='primary' fontSize='inherit' style={{ marginRight: '5px' }} />
      : <WarningIcon color='error' fontSize='inherit' style={{ marginRight: '5px' }} />
    return (
      <span style={{ alignItems: 'center', display: 'flex', marginLeft: 20, marginRight: 10 }}>
        {' '}{icon} {Y`${apiName}`}
      </span>
    )
  }

  render () {
    const { jetshopApiStatus, teliaApiStatus, azureApiStatus, hylteApiStatus } = this.props

    return (
      <div className='container' style={{ marginBottom: 10, justifyContent: 'flex-end' }}>
        <Typography variant='title' align='center'>
          {this.renderStatus('Hyltesim API', hylteApiStatus)}
        </Typography>
        <Typography variant='title' align='center'>
          {this.renderStatus('JetShop', jetshopApiStatus)}
        </Typography>
        <Typography variant='title' align='center'>
          {this.renderStatus('Telia', teliaApiStatus)}
        </Typography>
        <Typography variant='title' align='center'>
          {this.renderStatus('Azure', azureApiStatus)}
        </Typography>
      </div>
    )
  }
}

ApiStatus = connect(mapStateToProps, mapDispatchToProps)(ApiStatus)
export default withStyles(Styles)(ApiStatus)



// WEBPACK FOOTER //
// ./src/pages/admin/containers/api-status.js